import { Component } from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'app-registro-success',
    templateUrl: './registro-success.component.html',
    standalone: false
})
export class RegistroSuccessComponent {

  constructor(private router: Router) {
  }

  public goToActivation() {
    this.router.navigate(["/acesso/activar"], {queryParams: {fase: "pin"}}).then()
  }

}
